/* PWA install prompt registration helper. */
let deferredPrompt = null;
const listeners = new Set();

function notify() {
  for (const l of listeners) {
    try {
      l(Boolean(deferredPrompt));
    } catch {
      /* noop */
    }
  }
}

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    notify();
  });
}

export function onInstallAvailability(cb) {
  listeners.add(cb);
  cb(Boolean(deferredPrompt));
  return () => listeners.delete(cb);
}

export async function triggerInstall() {
  if (!deferredPrompt) return false;
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  deferredPrompt = null;
  notify();
  return choice && choice.outcome === "accepted";
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", async () => {
    try {
      // Remove any stale/foreign service workers (e.g. from a previous app that
      // lived on this domain) so they can't keep serving a cached old site.
      const regs = await navigator.serviceWorker.getRegistrations();
      for (const r of regs) {
        const scriptURL =
          (r.active && r.active.scriptURL) ||
          (r.waiting && r.waiting.scriptURL) ||
          (r.installing && r.installing.scriptURL) ||
          "";
        if (scriptURL && !scriptURL.endsWith("/sw.js")) {
          await r.unregister();
        }
      }

      const reg = await navigator.serviceWorker.register("/sw.js");
      // Proactively check for a newer service worker.
      reg.update().catch(() => {});

      // When a new service worker takes control, reload once so the freshly
      // deployed assets (HTML + JS) are used immediately.
      let reloaded = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (reloaded) return;
        reloaded = true;
        window.location.reload();
      });
    } catch (err) {
      console.warn("SW registration failed:", err);
    }
  });
}
